//replace html chars with something else
import {log} from "../libs/QuerloLogger";

const mapObj: any = {
    "<p>":"",
    "</p>":"<br/>"
  },
  re = new RegExp(Object.keys(mapObj).join("|"),"gi");

function getIndicesOf(searchStr: string, str: string, caseSensitive?: boolean): any {
  const searchStrLen = searchStr.length;
  if (searchStrLen == 0) return [];
  let startIndex = 0, index;
  const indices = [];
  if (!caseSensitive) {
    str = str.toLowerCase();
    searchStr = searchStr.toLowerCase();
  }
  // log.info(str, searchStr, str.indexOf(searchStr, startIndex));
  while ((index = str.indexOf(searchStr, startIndex)) > -1) {
    indices.push(index);
    startIndex = index + searchStrLen;
  }
  // log.info(indices, searchStr, str)
  return indices;
}

//https://codepen.io/stevn/pen/jEZvXa
export default function typingAnim(elementRef: HTMLElement, text: string): Promise<boolean> {
  
  const element: HTMLElement = elementRef;
  const HTML: string = text.replace(re, function (matched) {
    return mapObj[matched];
  });
  log.info(HTML);
  
  element.classList.add("isTyping");
  
  const typeSpeed = 10;
  let cursorPosition = 0,
      innerTagRawHTML = '',
      innerTagElement: HTMLElement,
      entityRawHTML = '',
      entityElement: HTMLElement,
      writingTag = false,
      writingEntity = false,
      tagOpen = false,
      entityOpen = false,
      tempTypeSpeed = 0,
      tagsPos: any = [];
  
  const supportedEntities: any = [
    ['amp', '&'],
    ['lt', '<'],
    ['gt', '>'],
    ['nbsp', ' '],
    ['quot', '"']
  ];
  
  for (let i = 0; i < supportedEntities.length; i++) {
    const indices = getIndicesOf(`&${supportedEntities[i][0]};`, HTML);
    if (indices.length) tagsPos = tagsPos.concat(indices);
  }
  
  // log.info(tagsPos);
  return new Promise(function(resolve, reject) {

  const type = function(): void {
    
    if (writingTag) {
      innerTagRawHTML += HTML[cursorPosition];
    }
    
    if (writingEntity) {
      entityRawHTML += HTML[cursorPosition];
    }
    
    // if (HTML[cursorPosition] === "<" && tagsPos.includes(cursorPosition)) {
    if (HTML[cursorPosition] === "<") {
      // log.info(cursorPosition, HTML[cursorPosition] + HTML[cursorPosition+1] +  HTML[cursorPosition+2]);
      tempTypeSpeed = 0;
      if (tagOpen) {
        tagOpen = false;
        writingTag = true;
      } else {
        innerTagRawHTML = '';
        tagOpen = true;
        writingTag = true;
        innerTagRawHTML += HTML[cursorPosition];
      }
    }
    if (HTML[cursorPosition] === "&" && tagsPos.includes(cursorPosition)) {
      // log.info(cursorPosition, HTML[cursorPosition] + HTML[cursorPosition+1] +  HTML[cursorPosition+2]);
      tempTypeSpeed = 0;
      if (entityOpen) {
        entityOpen = false;
        writingEntity = true;
      } else {
        entityRawHTML = "";
        entityOpen = true;
        writingEntity = true;
        entityRawHTML += HTML[cursorPosition];
      }
    }
    
    if (!writingTag && tagOpen && innerTagElement) {
      innerTagElement.innerHTML += HTML[cursorPosition];
    }
    if (!writingEntity && entityOpen && entityElement) {
      entityElement.innerHTML += HTML[cursorPosition];
    }
    
    if (!writingTag && !tagOpen && !writingEntity && !entityOpen) {
      if (HTML[cursorPosition] === " ") {
        tempTypeSpeed = 0;
      } else {
        tempTypeSpeed = (Math.random() * typeSpeed) + 50;
      }
      element.innerHTML += HTML[cursorPosition];
    }
    
    if (writingTag && HTML[cursorPosition] === ">") {
      tempTypeSpeed = (Math.random() * typeSpeed) + 50;
      writingTag = false;
      if (tagOpen) {
        const newSpan: HTMLElement = document.createElement("span")!;
        element.appendChild(newSpan);
        newSpan.innerHTML = innerTagRawHTML;
        innerTagElement = newSpan.firstChild as HTMLElement;
      }
    }
    
    if (writingEntity && HTML[cursorPosition] === ";") {
      tempTypeSpeed = (Math.random() * typeSpeed) + 50;
      writingEntity = false;
      if (entityOpen) {
        const newSpan = document.createElement("span");
        element.appendChild(newSpan);
        newSpan.innerHTML = entityRawHTML;
        entityElement = newSpan.firstChild as HTMLElement;
        entityOpen = false; //why this if the tag breaks with the same line?
      }
    }
    
    cursorPosition += 1;
    if (cursorPosition < HTML.length) {
      // TODO update the viewport scroll
      // scope.$emit('EVT_UPDATE_VIEW');
      setTimeout(type, tempTypeSpeed);
    } else {
      log.trace('END ANIMATION')
      // scope.$emit('EVT_QUEUE_GO');
      resolve(true);
      element.classList.remove("isTyping");
    }
    
  };
    type();
  });
}
